import { z } from "zod";

const authErrorPayloadSchema = z.object({
  code: z.string().optional(),
  error_code: z.string().optional(),
  detail: z.string().optional(),
});

export type AuthErrorCode =
  | "AUTH_FAILED"
  | "ROSTER_NOT_ELIGIBLE"
  | "TOKEN_FETCH_FAILED"
  | "TOKEN_LOGIN_FAILED"
  | "SESSION_LOAD_FAILED";

export class AuthError extends Error {
  readonly name = "AuthError";
  readonly code: AuthErrorCode;
  readonly status: number | null;

  constructor({
    code,
    message,
    status = null,
  }: {
    readonly code: AuthErrorCode;
    readonly message: string;
    readonly status?: number | null;
  }) {
    super(message);
    this.code = code;
    this.status = status;
  }
}

export function parseAuthErrorPayload(value: unknown): {
  readonly code?: string;
  readonly error_code?: string;
  readonly detail?: string;
} {
  const parsed = authErrorPayloadSchema.safeParse(value);
  return parsed.success ? parsed.data : {};
}

export function isRosterNotEligible({
  status,
  code,
  detail,
}: {
  readonly status: number;
  readonly code: string | undefined;
  readonly detail: string | undefined;
}): boolean {
  return (
    code === "ROSTER_NOT_ELIGIBLE" ||
    (status === 501 && detail?.includes("AI근무표 이용 대상") === true)
  );
}
